import { render, staticRenderFns } from "./screen-team-item.vue?vue&type=template&id=0d04ce42&scoped=true"
import script from "./screen-team-item.vue?vue&type=script&lang=ts"
export * from "./screen-team-item.vue?vue&type=script&lang=ts"
import style0 from "./screen-team-item.vue?vue&type=style&index=0&id=0d04ce42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d04ce42",
  null
  
)

export default component.exports